import React from 'react';
import { FeaturesSection } from './features-section';
import { JswConfigHeader } from './jsw-config-header';

/**
 * Display jsw configuration content
 * @returns {*}
 * @constructor
 */
export const JswConfigurationContent = () => (
	<>
		<JswConfigHeader />
		<FeaturesSection />
	</>
);
